import { useState } from "react";
import PropertyBadge from "./PropertyBadge";

const CharacteristicRow = ({ char, service, isSelected, onClick, index }) => {
  const [hovered, setHovered] = useState(false);
  const canRead   = char.properties?.includes("read");
  const canWrite  = char.properties?.includes("write");
  const canNotify = char.properties?.includes("notify");
 
  const active = isSelected || hovered;
 
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: "12px 14px",
        marginBottom: 6,
        cursor: "pointer",
        borderRadius: 10,
        background: isSelected
          ? "linear-gradient(135deg, #1e40af 0%, #1d4ed8 100%)"
          : hovered
          ? "#f0f7ff"
          : "#f8fafc",
        border: `1.5px solid ${isSelected ? "transparent" : hovered ? "#bfdbfe" : "#e2e8f0"}`,
        transition: "all 0.18s ease",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        transform: active && !isSelected ? "translateX(3px)" : "none",
        boxShadow: isSelected
          ? "0 4px 16px rgba(29,78,216,0.3), inset 0 1px 0 rgba(255,255,255,0.1)"
          : hovered
          ? "0 2px 8px rgba(99,102,241,0.1)"
          : "none",
        animation: `fadeSlideIn 0.25s ease ${index * 0.04}s both`,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        {/* Selection indicator */}
        <div style={{
          width: 18, height: 18, borderRadius: "50%",
          border: `2px solid ${isSelected ? "rgba(255,255,255,0.6)" : hovered ? "#93c5fd" : "#cbd5e1"}`,
          background: isSelected ? "rgba(255,255,255,0.25)" : "transparent",
          display: "flex", alignItems: "center", justifyContent: "center",
          flexShrink: 0,
          transition: "all 0.18s",
        }}>
          {isSelected && (
            <svg viewBox="0 0 12 12" fill="none" style={{ width: 8, height: 8 }}>
              <path d="M2 6l3 3 5-5" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
        </div>
 
        <div>
          <div style={{
            fontSize: 13, fontWeight: isSelected ? 600 : 500,
            color: isSelected ? "white" : hovered ? "#1e40af" : "#1e293b",
            transition: "color 0.18s",
            lineHeight: 1.3,
          }}>
            {char.description}
          </div>
          <div style={{
            fontSize: 10, color: isSelected ? "rgba(255,255,255,0.65)" : "#94a3b8",
            fontFamily: "monospace", marginTop: 2,
            transition: "color 0.18s",
          }}>
            UUID: {char.char_uuid}
          </div>
        </div>
      </div>
 
      <div style={{ display: "flex", gap: 4, flexShrink: 0 }}>
        {canRead   && <PropertyBadge type="read"   expanded={isSelected} />}
        {canWrite  && <PropertyBadge type="write"  expanded={isSelected} />}
        {canNotify && <PropertyBadge type="notify" expanded={isSelected} />}
      </div>
    </div>
  );
};


export default CharacteristicRow;